module.exports = __webpack_public_path__ + "static/media/3ad0b7f4-bbf4-4194-93a4-6a02faccb07a_1.5a63d1093664d395d98bc06cf4d5ef8c.cfcb0078.jpeg";